module.exports = __webpack_public_path__ + "img/missionStart.d2bcda01.jpg";